<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Penalidade"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <penalidade-form
            tipoOperacao="a"
            :showModal="showModal"
            @modalFechado="showModal = false"
            @obterPenalidadesAtualizadas="$emit('obterPenalidadesAtualizadas')"
            :contrato="contrato"
            :penalidadeId="penalidade.penalidadeId"
        ></penalidade-form>
    </div>
</template>

<script>
import PenalidadeForm from './PenalidadeForm'

export default {
	components: {
		PenalidadeForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		},

		penalidade: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
